<template>
    <div>
        <div class="row">
            <b-modal size="lg"
                     button-size="sm"
                     id="TAMInvoicePositionHoursDialog" centered title="Stunden Auswahl"
                     @ok="handleOk"
                     @shown="dialogReset"
                     cancel-title="Abbrechen"
                     ref="TAMInvoicePositionHoursDialogRef"
            >
                <div class="container">

                    <div class="row">
                        <div class="col-12">
                            <div v-if="billingProject">

                                <v-client-table :data="hours" :columns="columns" :options="options" class="invoice-table">

                                    <span slot="billId" slot-scope="props" class="text-darker">
                                        <toggle-button :value="props.row.billId" :color="'#28a745'" :sync="true" :labels="{checked: 'ja', unchecked: 'nein'}" @change="onAddToBill($event, props.row)" />
                                    </span>
                                    <span slot="dateFrom" slot-scope="props" class="text-darker"><span v-if="props.row.dateFrom">{{props.row.dateFrom | moment('DD.MM.YYYY')}}</span></span>
                                    <span slot="dateTo" slot-scope="props" class="text-darker"><span v-if="props.row.dateTo">{{props.row.dateTo | moment('DD.MM.YYYY')}}</span></span>
                                    <span slot="createDate" slot-scope="props" class="text-darker">{{props.row.createDate | moment('DD.MM.YYYY HH:mm')}}</span>

                                </v-client-table>
                            </div>
                        </div>
                    </div>

                    <div class="form-row" v-if="unitePositionVisible">
                        <div class="form-group col-12">
                            <label class="mr-3">Positionen zusammenfassen</label>
                            <toggle-button :value="unitePositions" :color="'#28a745'" :labels="{checked: 'ja', unchecked: 'nein'}" @change="onUnitePositions($event)" />
                        </div>

                        <div class="form-group col-12" v-if="showUnitedDescription">
                            <label for="textAreaDescription">Einheitliche Beschreibung</label>
                            <b-form-textarea id="textAreaDescription"
                                             v-model="unitedDescription"
                                             :rows="4"
                                             :max-rows="6"
                                             name="textAreaDescription"
                            >
                            </b-form-textarea>
                            <span v-show="unitePositions && unitedDescription === ''" class="error-message">Wenn du Stunden zusammenfasst, musst du eine Beschreibung eingeben</span>
                        </div>
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>

    export default {

        name: 'TAMPositionDialog',

        props: {
            project: Object
        },

        data: function() {

            return {
                columns: ['amount', 'description', 'jira', 'dateFrom', 'dateTo', 'billId'],

                unitePositions: false,
                unitedDescription: '',
                hoursToBook: [],
                billingProject: null,

                options: {
                    skin: 'table data-table',
                    filterable: false,
                    headings: {
                        amount: 'Anzahl',
                        description: 'Beschreibung',
                        jira: 'Jira',
                        dateFrom: 'Leistung von',
                        dateTo: 'Leistung bis',
                        billId: 'Abrechnen'
                    }
                }
            }
        },

        computed: {

            hours: function() {
                return this.billingProject.usedHours.filter(h => !h.billId);
            },

            unitePositionVisible: function() {

                if (this.hoursToBook.length < 2 ) {
                    return false;
                }

                return true;
            },

            showUnitedDescription: function() {

                if (!this.unitePositions) {
                    return false;
                }

                const refValue = this.hoursToBook[0].description;

                for (let i = 1; i < this.hoursToBook.length; i++) {

                    if (this.hoursToBook[i].description !== refValue) {
                        return true;
                    }
                }
                return false;
            }
        },

        methods: {

            onUnitePositions() {

                this.unitePositions = !this.unitePositions;
            },

            onAddToBill($event, value) {

                if ($event.value) {
                    if (this.hoursToBook.indexOf(value) === -1) {
                        this.hoursToBook.push(value);

                        if (this.hoursToBook.length === 1) {
                            this.unitedDescription = value.description;
                        }
                    }
                } else {

                    const index = this.hoursToBook.indexOf(value);
                    if (index !== -1) {
                        this.hoursToBook.splice(index, 1);
                        if (this.hoursToBook.length === 0) {
                            this.unitedDescription = '';
                        }
                    }
                }
            },

            dialogReset() {

                this.$validator.reset();
                this.unitePositions = false;
                this.unitedDescription = '';
                this.hoursToBook = [];
                this.billingProject = null;

                this.$nextTick()
                    .then(() => {
                        this.billingProject = this.project;
                    });

            },

            emitSave(invoicePosition) {

                this.$emit('save', invoicePosition);
            },

            handleOk() {

                if (this.hoursToBook.length > 0) {

                    if (this.hoursToBook.length > 1) {

                        if (this.unitePositions) {
                            this.emitSave(this.createUnitedPosition());
                        } else {
                            let data = [];

                            this.hoursToBook.forEach(v => {
                                data.push({work: v.description, dateFrom: v.dateFrom, dateTo: v.dateTo, amount: v.amount, price: this.project.hourrate});
                            });

                            this.emitSave(data);
                        }
                    } else {
                        let data = this.hoursToBook[0];
                        this.emitSave({work: data.description, dateFrom: data.dateFrom, dateTo: data.dateTo, amount: data.amount, price: this.project.hourrate});
                    }
                }

                this.hoursToBook.forEach(v => {

                    let obj = this.project.usedHours.filter(x => x.id === v.id);

                    if (obj.length === 1) {
                        obj[0].billId = '_';
                    }
                });
            },

            createUnitedPosition() {

                let amount = this.hoursToBook.map(v => v.amount).reduce((x, y) => x + y, 0);

                let minDate =
                    this.hoursToBook.filter(e => e.dateFrom)
                        .map(v => this.$moment(v.dateFrom))
                        .reduce((d1, d2) => {
                            return d1.isAfter(d2) ? d2 : d1;
                        });

                let maxDate =
                    this.hoursToBook.filter(e => e.dateTo)
                        .map(v => this.$moment(v.dateTo))
                        .reduce((d1, d2) => {
                            return d1.isAfter(d2) ? d1 : d2;
                        });


                return {work: this.unitedDescription, dateFrom: minDate.format(), dateTo: maxDate.format(), amount: amount, price: this.project.hourrate};
            },

            openDialog() {
                this.$refs.TAMInvoicePositionHoursDialogRef.show();
            }
        }
    }

</script>

<style scoped lang="scss">

</style>